module.exports = __webpack_public_path__ + "img/icon-herbarium.b1cc4a6c.svg";